import { getToken, setToken, removeToken } from '@/utils/cookie'

const state = {
  token: getToken()
}

const mutations = {
  SET_TOKEN: (state, token) => {
    setToken(token)
    state.token = token
  },
  REMOVE_TOKEN: () => {
    removeToken()
    state.token = ''
  }
}

const actions = {
  setToken ({ commit }, token) {
    return new Promise((resolve, reject) => {
      commit('SET_TOKEN', token)
      resolve()
    })
  }
}

export default {
  namespaced: true,
  actions,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js